<template>
  <div class="columns search-columns">
    <div class="column">
<!--      <leader-board></leader-board>-->
<!--      <leader-board-mobile></leader-board-mobile>-->
      <!-- <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdsListForPage" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad> -->
      <p v-if="!isMobileAds" class="has-text-centered">
        <fuse-ad name="search_results_header" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
        <!-- <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="secondAd" :no-top-margin="hideFirstDesktopAd"></ad> -->
      </p>
      <p v-if="isMobileAds" class="has-text-centered">
        <fuse-ad name="search_results_header" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
        <!-- <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="firstAd"  :no-top-margin="hideFirstDesktopAd"></ad> -->
      </p>
      <p v-if="fetching_data" class="has-text-centered spinner"><img src="/static/img/others/spinner.svg" alt="Fetching businesses linked to search term..." /></p>
      <p :class="['is-size-5', 'has-text-weight-bold', 'results-copy', { 'bottom-spacer' : totalBusinesses === 0 }]" v-if="!fetching_data" v-html="resultsCopy"></p>
      <!-- FILTER DROPDOWN -->
      <div v-if="totalBusinesses > 0" :disabled="disableDropDown" :class="['control', {'disabled':disableDropDown}]">
        <div class="dropdown" :class="{'is-active' : show_dropdown}" @mouseleave="hideDropdown()">
          <div class="dropdown-trigger">
            <button :disabled="disableDropDown" class="button-dropdown" aria-haspopup="true" @click.prevent="showDropdown()" @focus="closeOrgLookup()" aria-controls="dropdown-menu3">
              <span :class="['is-size-6', {'disabled':disableDropDown}]" ref="filter_name" v-html="selectedFilter"></span>
              <span :class="['icon', 'is-small', {'disabled':disableDropDown}]"><i class="fas fa-angle-down" aria-hidden="true"></i></span>
            </button>
          </div>
          <div class="dropdown-menu" role="menu">
            <div class="dropdown-content is-paddingless">
              <a v-for="searchFilter in filterList" href="#"
                 :ref="`${searchFilter.value}`"
                 class="dropdown-item"
                 @focus="closeOrgLookup()"
                 @click.prevent="selectFilter(searchFilter)"
                 v-html="searchFilter.name">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!fetching_data" v-for="businessRecord in businesses">
        <div class="columns is-paddingless business-row is-multiline">
          <div class="column is-hidden-desktop is-four-fifths is-hidden-mobile">
            <p class="has-text-weight-bold"><a :href="`/${businessRecord.slug}`" v-html="businessRecord.name"></a></p>
          </div>
          <div class="column is-hidden-desktop is-one-fifth is-hidden-mobile">&nbsp;</div>
          <div class="column is-one-third is-hidden-tablet-only">
            <p class="has-text-weight-bold"><a :href="`/${businessRecord.slug}`" v-html="businessRecord.name"></a></p>
          </div>
          <div class="column is-narrow">
            <rating :stars="businessRecord.newRating" :industry-business="shrinkStars"></rating>
          </div>
          <div class="column">
            <p class="has-text-right-tablet has-text-left-mobile" v-html="businessRecord.summary"></p>
          </div>
        </div>
        <div class="columns"><div class="column"><div>&nbsp;</div></div></div>
      </div>
      <paginator :dataSet="dataSet" @changed="fetchBusinesses"></paginator>
    </div>
  </div>
</template>
<script>
  import qs from 'qs'
  import axios from 'axios'
  import Rating from '@/components/Rating'
  import Paginator from '@/components/Paginator'
  import LeaderBoard from '@/components/LeaderBoardFluid'
  import LeaderBoardMobile from '@/components/LeaderBoardMobile'
  import adsConfig from '@/mixins/ad_config'
  import Ad from '@/components/ProgrammaticAds'
  import FuseAd from '@/components/ProgrammaticFuseAds'

  export default {
    components: {
      Rating,
      Paginator,
      LeaderBoard,
      LeaderBoardMobile,
      Ad,
      FuseAd
    },
    mixins: [adsConfig],
    metaInfo () {
      return {
        title: this.meta_title,
        titleTemplate: '%s | Hellopeter.com',
        meta: [
          { name: 'description', content: this.searchKey }
        ],
        bodyAttrs: {
          class: 'business'
        }
      }
    },
    data () {
      return {
        firstFetch: false,
        searchKey: '',
        current_businesses_fetch_url: '',
        fetching_data: false,
        totalReviews: 0,
        totalBusinesses: 0,
        keyword_search: '',
        filter_search: '',
        show_dropdown: false,
        businesses_pagination: {
          current_page: 1,
          last_page: 1
        },
        dataSet: [],
        businesses: [],
        shrinkStars: true,
        selectedFilter: 'Order by...',
        filterList: [
          {
            name: 'Most reviews',
            value: 'most-reviews'
          },
          {
            name: 'Alphabetical A - Z',
            value: 'a-z'
          },
          {
            name: 'Alphabetical Z - A',
            value: 'z-a'
          },
          {
            name: 'Top ranking',
            value: 'top-ranking'
          },
        ],
      }
    },
    created () {
      if (this.$route.query.search) {
        this.searchKey = this.$route.query.search
        let query = location.search.match(/page=(\d+)/)
        let page = query ? query[1] : 1
        this.fetchBusinesses(page)
      } else {
        window.location.href = '/404'
      }
    },
    mounted () {
      // this.loadFuseAds()
      // this.loadAds()
    },
    watch: {
      $route (to, from) {
        if (this.$route.query.search && this.$route.query.search !== this.searchKey) {
          window.location.reload()
        }
      }
    },
    computed: {
      disableDropDown () {
        return false
      },
      resultsCopy () {
        return `${this.totalBusinesses} results found for <i>${this.searchKey}</i>`
      },
      meta_title () {
        return `Reviews and Businesses search results for "${this.searchKey}"`
      }
    },
    methods: {
      async fetchBusinesses (page) {
        const businessesUrl = this.url(page, this.keyword_search, this.filter_search, this.searchKey)
        if (businessesUrl !== this.current_businesses_fetch_url) {
          this.current_businesses_fetch_url = businessesUrl
          this.fetching_data = true
          window.scrollTo(0, 0)
          axios.get(businessesUrl)
            .then((response) => {
              this.dataSet = response.data
              this.totalBusinesses = response.data.total
              const tmp = response.data.data
              this.businesses = tmp.map((business) => {
                const totalReviews = business.total_reviews.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                let rating = parseFloat(business.average_rating)
                let trustIndex = parseFloat(business.current_trust_index)
                let newRating = Math.floor(rating)
                let newTrustIndex = trustIndex.toFixed(1)
                business.newRating = newRating
                business.summary = `${totalReviews} reviews`
                if (business.current_trust_index > 0) {
                  business.summary = `${totalReviews} reviews | TrustIndex ${newTrustIndex}`
                }
                window.prerenderReady = true
                if (!this.firstFetch) {
                  this.firstFetch = true
                  this.$gtm.trackEvent({
                    event: 'pageLoad',
                    virtualPageUrl: this.$router.currentRoute.path,
                    virtualPageTitle: this.meta_title
                  })
                }
                return business
              })
              this.businesses_pagination.current_page = response.current_page
              this.businesses_pagination.last_page = response.last_page
              this.fetching_data = false
            })
            .catch((error) => {
              console.log('error', error)
              this.fetching_data = false
            })
        } else {
          window.prerenderReady = true
        }
      },
      url (page, keyword, filter, searchString) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)

          page = query ? query[1] : 1
        }

        if (keyword.length > 0) {
          const orderBy = qs.stringify({order: keyword})
          page += `&${orderBy}`
        }

        if (filter.length > 0) {
          const filterField = qs.stringify({filter: filter})
          page += `&${filterField}`
        }

        if (searchString.length > 0) {
          const searchField = qs.stringify({search: searchString})
          page += `&${searchField}`
        }

        return `/consumer/search?page=${page}`
      },
      hideDropdown () {
        this.show_dropdown = false
      },
      showDropdown () {
        this.show_dropdown = !this.show_dropdown
      },
      closeOrgLookup () {
        //
      },
      selectFilter (filter) {
        this.hideDropdown()
        this.selectedFilter = filter.name
        let updateList = true
        switch (filter.value) {
          case 'most-reviews':
            this.keyword_search = 'desc'
            this.filter_search = 'total_reviews'
            break
          case 'top-ranking':
            this.keyword_search = 'desc'
            this.filter_search = 'current_trust_index'
            break
          case 'a-z':
            this.keyword_search = 'asc'
            this.filter_search = 'orgs.name'
            break
          case 'z-a':
            this.keyword_search = 'desc'
            this.filter_search = 'orgs.name'
            break
          default:
            updateList = false
            break
        }
        if (updateList) {
          this.fetchBusinesses()
        }
      },
    }
  }
</script>
<style scoped>
  .search-columns {
    max-width: 1125px;
    margin: 8rem auto 2rem auto;
  }

  .dropdown {
    display: block;
    width: 100%;
  }

  .dropdown-trigger {
    text-align: left;
    width: 100%;
  }

  .button-dropdown {
    text-align: left;
    justify-content: left;
    min-width: 100%;
    color: #8A8C91 !important;
    background-color: #fff !important;
    border-color: #dbdbdb !important;
    min-height: 39px !important;
  }

  .dropdown-menu {
    border-top: 3px solid #30AAE1;
    width: 100%;
    padding-top: 0 !important;
    border-bottom: 1px solid #e1dfdf;
  }

  .fa-angle-down {
    font-size: 1.4rem;
  }

  .fa-angle-down:before {
    right: 0.7em;
  }

  .fa-angle-down:before {
    border: 1px solid #95979b;
    border-right: 0;
    border-top: 0;
    content: " ";
    display: block;
    height: 0.5em;
    pointer-events: none;
    position: absolute;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: center;
    transform-origin: center;
    width: 0.5em;
    margin-top: -0.375em;
    right: 1.125em;
    top: 50%;
    z-index: 4;
  }

  a.dropdown-item:hover {
    background-color: #30AAE1;
    color: #fff;
  }

  .dropdown-item {
    padding: 10px !important;
    border: 1px solid transparent;
  }

  .dropdown-content {
    border-radius: 0;
    overflow-y: scroll;
    height: 200px;
  }

  .control {
    margin-bottom: 50px;
  }

  .business-row + .columns > .column > div {
    border-top: 1px solid #C9C9C9;
    height: 15px;
  }

  .business-row p {
    font-size: 0.9rem;
    color: #58595B;
  }

  .business-row a, .business-row a:visited, .business-row a:hover {
    text-decoration: none;
    font-size: 0.9rem;
    color: #58595B;
  }

  .spacer {
    margin-top: 30px;
  }

  .hide-pagination-mobile > nav {
    display: flex;
  }

  @media screen and (max-width: 1024px) {
    .img-container {
      width: 144px;
      height: 144px;
    }

    .img-container .image {
      width: 70px;
    }

    .search-columns {
      max-width: 95%;
    }

    .totals-columns {
      max-width: 100%;
      margin: 0 auto;
    }

    .totals-card {
      width: 186px;
      margin-left: auto;
      margin-right: auto;
    }

    .totals-columns > .column:nth-child(2) > .totals-card:first-child {
      margin-top: 1rem;
    }

    .img-container + h4 {
      max-width: 186px;
      margin-left: auto;
      margin-right: auto;
    }

    #seo-copy {
      max-width: 186px;
      margin-left: auto;
      margin-right: auto;
    }

    .business-row > .column {
      overflow-x: hidden;
    }

    .business-row > .column.is-hidden-desktop {
      padding-bottom: 0;
    }

    .business-row > .column.is-one-third.is-hidden-tablet-only ~ .column {
      padding-top: 0;
    }
  }

  @media screen and (max-width: 767px) {
    .img-container {
      width: 70px;
      height: 70px;
      margin: 0 auto 1.5rem auto;
    }

    .img-container .image {
      width: 40px;
    }

    .search-columns {
      width: 100%;
      max-width: 100%;
      margin: 4rem 0 2rem 0;
    }

    .search-columns > .column:first-child {
      padding-top: 2rem;
      padding-bottom: 0;
    }

    .tabs-columns {
      background-color: #ffffff;
      margin-top: 1rem;
    }

    .tabs {
      background-color: #F5F5F5;
      margin-bottom: 25px;
    }

    .tabs > ul {
      border: none;
    }

    .tabs > ul > li > a {
      color: #58595B;
      font-size: 0.9rem;
      border-bottom: none;
      padding: 0.7rem 1rem;
    }

    .tabs > ul > li.is-active > a {
      color: #2EAAE1;
      border-bottom: 3px solid #2EAAE1;
    }

    .control {
      margin-bottom: 35px;
    }

    .hide-pagination-mobile > nav {
      display: none;
    }
  }

  *:focus {
    outline: none;
  }

  .results-copy {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .bottom-spacer {
    margin-bottom: 300px!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/SearchResults.vue